import React from 'react';
import styled from 'styled-components';

import Alert from '@r1-frontend/ui-react/components/Alert';
import { InfoCircle } from '@r1-frontend/ui-react/components/svg/main';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';

type TRouterNotSupplySpeed = {
    onLinkClick: () => void,
}

const RouterNotSupplySpeed = ({ onLinkClick, ...props }: TRouterNotSupplySpeed) => (<Alert type={'error'} Icon={InfoCircle} {...props}>
        <Paragraph4>
            Роутер, который вы выбрали раньше, не поддерживает новую скорость, поэтому мы удалили его из заявки.
            Пожалуйста, <a onClick={onLinkClick}>выберите новый роутер.</a>
        </Paragraph4>
    </Alert>
);

export default styled(RouterNotSupplySpeed)`
    max-width: 345px;
    & a {
        cursor: pointer;
    }
`;
